import axios from 'axios'

const api = axios.create({
  // 74ae81d6de07482d9e2cc9679d6856e5
  // import.meta.env.VITE_APP_RUTA_API
  // https://tarjetasregaloback.rtic.info:7513/api
  baseURL: "https://tarjetasregaloback.rtic.info:7513/api",
})

// Interceptor para añadir token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
     config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

export default {
  // Autenticación
  login(email, password) {
    return api.post('/auth/login', { email, password })
  },
  loginWithToken: (token) => {
    return api.post('/auth/login_token', { token })
  },
  register(email, password, rol = 'operador', tienda_id) {
    return api.post('/auth/registro', { email, password, rol, tienda_id })
  },
  obtenerUsuarios(page, rowsPerPage, sortBy, descending, filter) {
    return api.post(`/auth/listar`, { page, rowsPerPage, sortBy, descending, filter })
  },

  //Tiendas
  actualizarConfiguracion(tienda_id, agoraToken) {
    return api.post("/tienda/config/", { tienda_id, agoraToken })
  },
  obtenerConfiguracion(tienda_id, token) {
    return api.get(`/tienda/config/${tienda_id}`, {token})
  },

  // Tarjetas
  crearTarjeta(tarjetaData) {
    return api.post('/tarjetas', tarjetaData)
  },
  obtenerTarjeta(uuid) {
    return api.get(`/tarjetas/${uuid}`)
  },
  obtenerTarjetas(page, rowsPerPage, sortBy, descending, filter) {
    return api.post(`/tarjetas/listar`, { page, rowsPerPage, sortBy, descending, filter })
  },
  borrarTarjeta(uuid) {
    return api.delete(`/tarjetas/${uuid}`)
  },

  // Movimientos
  createMovement(uuid, movementData) {
    return api.post(`/movimientos/${uuid}`, movementData)
  },
  getMovements(uuid) {
    return api.get(`/movimientos/${uuid}`)
  },
}
